import { useQuery } from '@tanstack/react-query';
import type { PalvelutunnusStats } from '@taksikortti/shared';
import { api } from './client';

export interface PalvelutunnuksetParams {
  q?: string;
  minCases?: number;
}

export interface PalvelutunnuksetResponse {
  rows: PalvelutunnusStats[];
}

function toQuery(p: PalvelutunnuksetParams): string {
  const u = new URLSearchParams();
  if (p.q) u.set('q', p.q);
  if (p.minCases != null) u.set('minCases', String(p.minCases));
  const s = u.toString();
  return s ? `?${s}` : '';
}

export function usePalvelutunnukset(params: PalvelutunnuksetParams) {
  return useQuery({
    queryKey: ['palvelutunnukset', 'list', params],
    queryFn: () => api<PalvelutunnuksetResponse>(`/palvelutunnukset${toQuery(params)}`),
    staleTime: 30_000,
  });
}
